// debugLog.ts — Gated logging utility for NeuroPsyMap
// All console output routes through here so it can be globally disabled
// in production or toggled at runtime via `window.__NEURO_DEBUG__`.

const DEBUG_DEFAULT = typeof window !== 'undefined'
	? !!((window as unknown as Record<string, unknown>).__NEURO_DEBUG__)
	: false;

let _debugEnabled = DEBUG_DEFAULT;

/** Global debug toggles — set via window.__NEURO_DEBUG__ or toggleDebug() */
export const DebugLog = {
	get enabled(): boolean { return _debugEnabled; },

	/** Toggle all debug output on/off at runtime */
	toggle(): boolean { _debugEnabled = !_debugEnabled; return _debugEnabled; },

	/** Enable debug output */
	enable(): void { _debugEnabled = true; },

	/** Disable all debug output (production mode) */
	disable(): void { _debugEnabled = false; },

	/** Gated log — only prints when debug is enabled */
	log(tag: string, ...args: unknown[]): void {
		if (!_debugEnabled) return;
		console.log(`[${tag}]`, ...args);
	},

	/** Gated warn */
	warn(tag: string, ...args: unknown[]): void {
		if (!_debugEnabled) return;
		console.warn(`[${tag}]`, ...args);
	},

	/** Gated error (always logs — errors should never be silent) */
	error(tag: string, ...args: unknown[]): void {
		console.error(`[${tag}]`, ...args);
	},

	/** Always-on audit log (for development milestones; throttled by caller) */
	audit(tag: string, ...args: unknown[]): void {
		console.log(`%c[AUDIT ${tag}]%c`, 'color:#0f0;font-weight:bold', 'color:inherit', ...args);
	},
};

// Expose toggle on window for runtime control
if (typeof window !== 'undefined') {
	const w = window as unknown as Record<string, unknown>;
	w.__NEURO_DEBUG_TOGGLE__ = () => DebugLog.toggle();
	w.__NEURO_DEBUG_ON__ = () => DebugLog.enable();
	w.__NEURO_DEBUG_OFF__ = () => DebugLog.disable();
}
